/* RESPONSIBLE TEAM: team-web */
import Route from '@ember/routing/route';

export default class ChangesRoute extends Route {
  beforeModel() {
    window.location.replace('https://intercom.com/changes');
  }
}
